import React from 'react';
import MediaQuery from 'react-responsive';

export default class MobileViewContainer extends React.Component {
  render() {
    const { children, styles, mobileStyles, id } = this.props;
    return (
      <React.Fragment>
        <MediaQuery query="(min-width: 768px)">
          {matches => {
            if (matches) {
              return (
                <div id={id} style={styles}>
                  {children}
                </div>
              );
            } else {
              return (
                <div id={id} style={mobileStyles}>
                  {children}
                </div>
              );
            }
          }}
        </MediaQuery>
      </React.Fragment>
    );
  }
}
